
import React from 'react';
import { FileManagementTabs } from './file-management/FileManagementTabs';

export const CsvUtilFileUpload = () => {
  return <FileManagementTabs />;
};
